export default __webpack_public_path__ + "static/media/logo512.3d5e4472.png";